<form clrForm
      [formGroup]="editOrdersForm">
  <table class="table" id="positionsTable" style="width: 100%; table-layout: fixed">
    <thead>
    <tr>
      <th class="left">Position</th>
      <th class="left">Bezeichnung</th>
      <th class="left">Zeichnungsnummer</th>
      <th class="left">Material</th>
      <th class="left">Gewicht (in kg)</th>
      <th class="left">Charge</th>
      <th>Anzahl</th>
      <th>Angebot in EUR</th>
      <th><span  *ngIf="(orderStatus !== 'open')">Lieferdatum</span></th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>{{ editPosition }}<span *ngIf="editPart !== 0">.{{ editPart }}</span></td>
      <td class="left">
        <b>{{ positions[0].name }}</b>
        <span *ngIf="((!positions[0].description) || (positions[0].description.length > 0))"><br />{{ positions[0].description }}</span>
      </td>
      <td class="left">{{ positions[0].technical_drawing }}</td>
      <td class="left">{{ positions[0].material }}</td>
      <td class="left"><input type="text" formControlName="weight" placeholder="{{ positions[0].weight }} " class="clr-input" value="{{ positions[0].weight }} "></td>
      <td class="left"><input type="text" formControlName="heat_nr" placeholder="{{ positions[0].heat_nr }} " class="clr-input" value="{{ positions[0].heat_nr }} "></td>
      <td><input type="number" formControlName="number_of_pieces" placeholder="{{ positions[0].number_of_pieces }}" class="clr-input" value="{{ positions[0].number_of_pieces }}"></td>
      <td><input type="text" formControlName="budget" placeholder="{{ positions[0].budget }}" class="clr-input" value="{{ positions[0].budget }}"></td>
      <td>
        <clr-date-container class="moveUp" *ngIf="(orderStatus !== 'open')">
          <label>am </label>
          <input type="date" clrDate placeholder="{{ positions[0].delivery_date | date: 'dd.MM.yyyy' }}" formControlName="delivery_date" required />
        </clr-date-container>
      </td>
      <td rowspan="5" class="btn-group btn-primary btn-icon">
        <button class="btn btn-sm" (click)="updateOrdersPosition()" [disabled]="editOrdersForm.invalid">
          <cds-icon shape="floppy"></cds-icon>
          <span class="clr-icon-title">Speichern</span>
        </button>
      </td>
    </tr>
    <tr *ngIf="positions[0].specification">
      <td colspan="3"></td>
      <td colspan="6" class="left" style="white-space: normal; overflow-wrap: break-word; word-break: break-word; max-width: 0">
        <b>Spezifikation:</b> {{ positions[0].specification }}
      </td>
    </tr>
    <tr *ngIf="positions[0].comment_phm">
      <td colspan="3"></td>
      <td colspan="6" class="left">
        <div class="clr-form-control">
          <label class="clr-control-label">Kommentar</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              {{ positions[0].comment_phm }}
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr *ngIf="positions[0].side_agreements">
      <td colspan="3"></td>
      <td colspan="6" class="left">
        <div class="clr-form-control">
          <label class="clr-control-label">Nebenabreden mit dem Lieferanten:</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              {{ positions[0].side_agreements }}
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="3"></td>
      <td colspan="6" class="left">
        <div class="clr-form-control">
          <label for="remarks" class="clr-control-label">Leistungsumfang</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <textarea formControlName="remarks" id="remarks" placeholder="{{ positions[0].remarks }}" rows="10" class="clr-textarea" style="width: 100%" value="{{ positions[0].remarks }}"></textarea>
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
            <span class="clr-subtext">Dieses Feld erscheint im Dokument unter der Position.</span>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</form>

<pre *ngIf="devMode" class="datepicker-output">
    {{ editOrdersForm.value | json }}
</pre>


